/**
 * Portal ICAVI - Serviço de domínio: Restaurantes
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const restaurantesServiceMethods = {
    /**
     * Lista restaurantes com filtros opcionais
     */
    async listarRestaurantes(params = {}) {
        try {
            const response = await api.get('/api/restaurantes/listar', {
                params,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar restaurantes:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Obtém restaurante por ID
     */
    async obterRestaurante(id) {
        try {
            const response = await api.get(`/api/restaurantes/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao obter restaurante:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Cria novo restaurante
     */
    async criarRestaurante(dados) {
        try {
            const response = await api.post('/api/restaurantes/criar', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar restaurante:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Atualiza restaurante existente
     */
    async atualizarRestaurante(id, dados) {
        try {
            const response = await api.put(`/api/restaurantes/${id}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar restaurante:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Exclui restaurante
     */
    async excluirRestaurante(id) {
        try {
            const response = await api.delete(`/api/restaurantes/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir restaurante:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
